<template>
  <div id="paginabilanciMinistero">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Bilancio Ministero</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropAnni"
                  ref="dropAnni"
                  :query="queryAnni"
                  :dataSource="anniData"
                  :index="anniIndex"
                  :fields="anniFields"
                  :change="onAnnoChange"
                  v-model="annoCorrente"
                  placeholder="Seleziona un Anno"
                ></ejs-dropdownlist>
              </b-col>

              <b-col
                xl="12"
                md="12"
                class="text-right mt-1"
                v-show="showButtonCreateBilancio"
              >
                <ejs-button
                  id="creaBilancioMinisteroButton"
                  cssClass="e-flat"
                  @click.native="creaBilancioMinisteroButton()"
                  >CREA BILANCIO MINISTERO PER L'ANNO SELEZIONATO
                </ejs-button>
              </b-col>

              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xl="12" md="12" class="pt-1">
        <div id="TabParent">
          <b-tabs ref="tabA" v-model="tabAIndex" v-show="showTabsBilancio">
            <b-tab
              title="BILANCIO MINISTERO PREVENTIVO"
              @click="tabClicked('tab01')"
            >
              <b-row class="match-height">
                <b-col xl="12" md="12">
                  <h3>&nbsp</h3>
                  <h3>ENTRATE BILANCIO PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Entrate</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrStataliExtraFUS" class="h5"
                            >Contributi Statali (extra FUS)</label
                          >
                          <ejs-numerictextbox
                            id="prevContrStataliExtraFUS"
                            v-model="
                              bilanciMinisteroActiveData.prevContrStataliExtraFUS
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi Statali (extra FUS)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrRegionali" class="h5"
                            >Contributi regionali</label
                          >
                          <ejs-numerictextbox
                            id="prevContrRegionali"
                            v-model="
                              bilanciMinisteroActiveData.prevContrRegionali
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi regionali"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrComunali" class="h5"
                            >Contributi comunali</label
                          >
                          <ejs-numerictextbox
                            id="prevContrComunali"
                            v-model="
                              bilanciMinisteroActiveData.prevContrComunali
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi comunali"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrUE" class="h5"
                            >Contributi da UE</label
                          >
                          <ejs-numerictextbox
                            id="prevContrUE"
                            v-model="bilanciMinisteroActiveData.prevContrUE"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi da UE"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrAltriEntiPubblici" class="h5"
                            >Contributi da altri enti pubblici</label
                          >
                          <ejs-numerictextbox
                            id="prevContrAltriEntiPubblici"
                            v-model="
                              bilanciMinisteroActiveData.prevContrAltriEntiPubblici
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi da altri enti pubblici"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrSoggettiPrivati" class="h5"
                            >Contributi da soggetti privati</label
                          >
                          <ejs-numerictextbox
                            id="prevContrSoggettiPrivati"
                            v-model="
                              bilanciMinisteroActiveData.prevContrSoggettiPrivati
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi da soggetti privati"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSponsorEconomiche" class="h5"
                            >Sponsorizzazioni economiche</label
                          >
                          <ejs-numerictextbox
                            id="prevSponsorEconomiche"
                            v-model="
                              bilanciMinisteroActiveData.prevSponsorEconomiche
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Sponsorizzazioni economiche"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRimborsiCoproduzione" class="h5"
                            >Rimborsi da coproduzione</label
                          >
                          <ejs-numerictextbox
                            id="prevRimborsiCoproduzione"
                            v-model="
                              bilanciMinisteroActiveData.prevRimborsiCoproduzione
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Rimborsi da coproduzione"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAltreEntrateCoproduzione" class="h5"
                            >Altre entrate da coproduzione</label
                          >
                          <ejs-numerictextbox
                            id="prevAltreEntrateCoproduzione"
                            v-model="
                              bilanciMinisteroActiveData.prevAltreEntrateCoproduzione
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altre entrate da coproduzione"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevEntrateAbbonamenti" class="h5"
                            >Entrate da abbonamenti</label
                          >
                          <ejs-numerictextbox
                            id="prevEntrateAbbonamenti"
                            v-model="
                              bilanciMinisteroActiveData.prevEntrateAbbonamenti
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Entrate da abbonamenti"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevIncassiBiglietteriaProdCoprod"
                            class="h5"
                            >Incassi da biglietteria (produz. E co-prod)</label
                          >
                          <ejs-numerictextbox
                            id="prevIncassiBiglietteriaProdCoprod"
                            v-model="
                              bilanciMinisteroActiveData.prevIncassiBiglietteriaProdCoprod
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Incassi da biglietteria (produz. E co-prod)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevIncassiBiglietteriaOspitalita"
                            class="h5"
                            >Incassi da biglietteria (ospitalità)</label
                          >
                          <ejs-numerictextbox
                            id="prevIncassiBiglietteriaOspitalita"
                            v-model="
                              bilanciMinisteroActiveData.prevIncassiBiglietteriaOspitalita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Incassi da biglietteria (ospitalità)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevIncassiPrevendita" class="h5"
                            >Incassi da prevendita</label
                          >
                          <ejs-numerictextbox
                            id="prevIncassiPrevendita"
                            v-model="
                              bilanciMinisteroActiveData.prevIncassiPrevendita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Incassi da prevendita"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevEntrateCompensiAttivita" class="h5"
                            >Entrate derivanti da compensi per attività</label
                          >
                          <ejs-numerictextbox
                            id="prevEntrateCompensiAttivita"
                            v-model="
                              bilanciMinisteroActiveData.prevEntrateCompensiAttivita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Entrate derivanti da compensi per attività"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevAltreEntrateAttivitaCaratteristica"
                            class="h5"
                            >Altre entrate da Attività Caratteristica</label
                          >
                          <ejs-numerictextbox
                            id="prevAltreEntrateAttivitaCaratteristica"
                            v-model="
                              bilanciMinisteroActiveData.prevAltreEntrateAttivitaCaratteristica
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altre entrate da Attività Caratteristica"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevEntrateServiziAccessori" class="h5"
                            >Entrate da servizi accessori</label
                          >
                          <ejs-numerictextbox
                            id="prevEntrateServiziAccessori"
                            v-model="
                              bilanciMinisteroActiveData.prevEntrateServiziAccessori
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Entrate da servizi accessori"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAltreEntrateAltreAttivita" class="h5"
                            >Altre entrate (es quote sociali)</label
                          >
                          <ejs-numerictextbox
                            id="prevAltreEntrateAltreAttivita"
                            v-model="
                              bilanciMinisteroActiveData.prevAltreEntrateAltreAttivita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altre entrate (es quote sociali)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>

                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevTotaleEntrate" class="h5"
                            >TOTALE ENTRATE BILANCIO PREVENTIVO</label
                          >
                          <ejs-numerictextbox
                            id="prevTotaleEntrate"
                            v-model="prevTotaleEntrate"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Totale Entrate"
                            showSpinButton="false"
                            showClearButton="true"
                            :readonly="true"
                          />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>USCITE BILANCIO PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Uscite</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevOneriSocialiDirettoreArtisticoCaricoA"
                            class="h5"
                            >Oneri sociali direttore artistico carico A.</label
                          >
                          <ejs-numerictextbox
                            id="prevOneriSocialiDirettoreArtisticoCaricoA"
                            v-model="
                              bilanciMinisteroActiveData.prevOneriSocialiDirettoreArtisticoCaricoA
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Oneri sociali direttore artistico carico A."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCompensoDirettoreArtistico" class="h5"
                            >Compenso direttore artistico</label
                          >
                          <ejs-numerictextbox
                            id="prevCompensoDirettoreArtistico"
                            v-model="
                              bilanciMinisteroActiveData.prevCompensoDirettoreArtistico
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Compenso direttore artistico"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevRetribuzioneLordaPersonaleArtistico"
                            class="h5"
                            >Retribuzione lorda personale artistico</label
                          >
                          <ejs-numerictextbox
                            id="prevRetribuzioneLordaPersonaleArtistico"
                            v-model="
                              bilanciMinisteroActiveData.prevRetribuzioneLordaPersonaleArtistico
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Retribuzione lorda personale artistico"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevOneriSocialiPersonaleArtisticoCaricoA"
                            class="h5"
                            >Oneri sociali personale artistico carico A.</label
                          >
                          <ejs-numerictextbox
                            id="prevOneriSocialiPersonaleArtisticoCaricoA"
                            v-model="
                              bilanciMinisteroActiveData.prevOneriSocialiPersonaleArtisticoCaricoA
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Oneri sociali personale artistico carico A."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevRetribuzioneLordaPersonaleTecnico"
                            class="h5"
                            >Retribuzione lorda personale tecnico</label
                          >
                          <ejs-numerictextbox
                            id="prevRetribuzioneLordaPersonaleTecnico"
                            v-model="
                              bilanciMinisteroActiveData.prevRetribuzioneLordaPersonaleTecnico
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Retribuzione lorda personale tecnico"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevOneriSocialiPersonaleTecnicoCaricoA"
                            class="h5"
                            >Oneri sociali personale tecnico carico A.</label
                          >
                          <ejs-numerictextbox
                            id="prevOneriSocialiPersonaleTecnicoCaricoA"
                            v-model="
                              bilanciMinisteroActiveData.prevOneriSocialiPersonaleTecnicoCaricoA
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Oneri sociali personale tecnico carico A."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevRetribuzioneLordaPersonaleAmm"
                            class="h5"
                            >Retribuzione lorda personale amm.vo</label
                          >
                          <ejs-numerictextbox
                            id="prevRetribuzioneLordaPersonaleAmm"
                            v-model="
                              bilanciMinisteroActiveData.prevRetribuzioneLordaPersonaleAmm
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Retribuzione lorda personale amm.vo"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevOneriSocialiPersonaleAmmCaricoA"
                            class="h5"
                            >Oneri sociali personale amm.vo carico A.</label
                          >
                          <ejs-numerictextbox
                            id="prevOneriSocialiPersonaleAmmCaricoA"
                            v-model="
                              bilanciMinisteroActiveData.prevOneriSocialiPersonaleAmmCaricoA
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Oneri sociali personale amm.vo carico A."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevDiarieForfettarie" class="h5"
                            >Diarie forfettarie</label
                          >
                          <ejs-numerictextbox
                            id="prevDiarieForfettarie"
                            v-model="
                              bilanciMinisteroActiveData.prevDiarieForfettarie
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Diarie forfettarie"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCompensiOrganismiOspitati" class="h5"
                            >Compensi organismi ospitati</label
                          >
                          <ejs-numerictextbox
                            id="prevCompensiOrganismiOspitati"
                            v-model="
                              bilanciMinisteroActiveData.prevCompensiOrganismiOspitati
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Compensi organismi ospitati"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevCostiViaggiTrasportoAlloggiCO"
                            class="h5"
                            >Costi viaggi, trasporto, alloggi C.O.</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiViaggiTrasportoAlloggiCO"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiViaggiTrasportoAlloggiCO
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi viaggi, trasporto, alloggi C.O."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevNoleggiTecniciOsp" class="h5"
                            >Noleggi tecnici ospitalità</label
                          >
                          <ejs-numerictextbox
                            id="prevNoleggiTecniciOsp"
                            v-model="
                              bilanciMinisteroActiveData.prevNoleggiTecniciOsp
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Noleggi tecnici"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevPrestazioniTerziAllestimentiOsp"
                            class="h5"
                            >Prestazioni di terzi x allestimenti(m/s/f) ospitalità</label
                          >
                          <ejs-numerictextbox
                            id="prevPrestazioniTerziAllestimentiOsp"
                            v-model="
                              bilanciMinisteroActiveData.prevPrestazioniTerziAllestimentiOsp
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Prestazioni di terzi x allestimenti(m/s/f)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSIAEOsp" class="h5"
                            >SIAE Ospitalità</label
                          >
                          <ejs-numerictextbox
                            id="prevSIAEOsp"
                            v-model="bilanciMinisteroActiveData.prevSIAEOsp"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="SIAE Ospitalità"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevVVFCaricoAziendaOsp" class="h5"
                            >VVF a carico azienda Ospitalità</label
                          >
                          <ejs-numerictextbox
                            id="prevVVFCaricoAziendaOsp"
                            v-model="
                              bilanciMinisteroActiveData.prevVVFCaricoAziendaOsp
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="VVF a carico azienda Ospitalità"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevCostiViaggiTrasportoAlloggiProduzioni"
                            class="h5"
                            >Costi viaggi, trasporto, alloggi Produzioni</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiViaggiTrasportoAlloggiProduzioni"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiViaggiTrasportoAlloggiProduzioni
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi viaggi, trasporto, alloggi Produzioni"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevAcquistiSceneCostumiStrumentiProd"
                            class="h5"
                            >Acquisti scene, costumi,strumenti ecc</label
                          >
                          <ejs-numerictextbox
                            id="prevAcquistiSceneCostumiStrumentiProd"
                            v-model="
                              bilanciMinisteroActiveData.prevAcquistiSceneCostumiStrumentiProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Acquisti scene, costumi,strumenti ecc"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevNoleggiSceneCostumiStrumentiProd"
                            class="h5"
                            >Noleggi scene, costumi,strumenti ecc</label
                          >
                          <ejs-numerictextbox
                            id="prevNoleggiSceneCostumiStrumentiProd"
                            v-model="
                              bilanciMinisteroActiveData.prevNoleggiSceneCostumiStrumentiProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Noleggi scene, costumi,strumenti ecc"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevAcquistiStrumentazioneTecnicaNonAmmProd"
                            class="h5"
                            >Acquisti strumentazione tecnica non amm.</label
                          >
                          <ejs-numerictextbox
                            id="prevAcquistiStrumentazioneTecnicaNonAmmProd"
                            v-model="
                              bilanciMinisteroActiveData.prevAcquistiStrumentazioneTecnicaNonAmmProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Acquisti strumentazione tecnica non amm."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevNoleggiStrumentazioneTecnicaProd"
                            class="h5"
                            >Noleggi strumentazione tecnica</label
                          >
                          <ejs-numerictextbox
                            id="prevNoleggiStrumentazioneTecnicaProd"
                            v-model="
                              bilanciMinisteroActiveData.prevNoleggiStrumentazioneTecnicaProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Noleggi strumentazione tecnica"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAffittoSalaProveProd" class="h5"
                            >Affitto sala prove</label
                          >
                          <ejs-numerictextbox
                            id="prevAffittoSalaProveProd"
                            v-model="
                              bilanciMinisteroActiveData.prevAffittoSalaProveProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Affitto sala prove"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevPrestazioniTerziAllestimentiProd"
                            class="h5"
                            >Prestazioni di terzi x allestimenti(m/s/f)</label
                          >
                          <ejs-numerictextbox
                            id="prevPrestazioniTerziAllestimentiProd"
                            v-model="
                              bilanciMinisteroActiveData.prevPrestazioniTerziAllestimentiProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Prestazioni di terzi x allestimenti(m/s/f)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSIAEProd" class="h5"
                            >SIAE Produzioni</label
                          >
                          <ejs-numerictextbox
                            id="prevSIAEProd"
                            v-model="bilanciMinisteroActiveData.prevSIAEProd"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="SIAE Produzioni"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevVVFCaricoAziendaProd" class="h5"
                            >VVF a carico azienda Produzioni</label
                          >
                          <ejs-numerictextbox
                            id="prevVVFCaricoAziendaProd"
                            v-model="
                              bilanciMinisteroActiveData.prevVVFCaricoAziendaProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="VVF a carico azienda Produzioni"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevUfficioStampaComunicazione" class="h5"
                            >Ufficio stampa e comunicazione</label
                          >
                          <ejs-numerictextbox
                            id="prevUfficioStampaComunicazione"
                            v-model="
                              bilanciMinisteroActiveData.prevUfficioStampaComunicazione
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Ufficio stampa e comunicazione"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevCostiStampeDistribAffissione"
                            class="h5"
                            >Costi stampe,distrib. E affissione</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiStampeDistribAffissione"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiStampeDistribAffissione
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi stampe,distrib. E affissione"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCostiPrestazioniPubblProm" class="h5"
                            >Costi per prestazioni (registr., video, ..)</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiPrestazioniPubblProm"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiPrestazioniPubblProm
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi per prestazioni (registr., video, audio, foto)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCostiPubblicita" class="h5"
                            >Costi per pubblicità</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiPubblicita"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiPubblicita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi per pubblicità"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCostiGestioneManSitoWeb" class="h5"
                            >Costi gestione e man.ne sito web</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiGestioneManSitoWeb"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiGestioneManSitoWeb
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi gestione e man.ne sito web"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCostiPromoPiattDig" class="h5"
                            >Costi promozione piattaforme digitali</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiPromoPiattDig"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiPromoPiattDig
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi promozione piattaforme digitali"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAffittoSpaziSpettacoli" class="h5"
                            >Affitto spazi per spettacoli</label
                          >
                          <ejs-numerictextbox
                            id="prevAffittoSpaziSpettacoli"
                            v-model="
                              bilanciMinisteroActiveData.prevAffittoSpaziSpettacoli
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Affitto spazi per spettacoli"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCostiManOrdinariaSpazi" class="h5"
                            >Costi di manutenzione ordinaria spazi</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiManOrdinariaSpazi"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiManOrdinariaSpazi
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi di manutenzione ordinaria spazi"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevUtenze" class="h5">Utenze</label>
                          <ejs-numerictextbox
                            id="prevUtenze"
                            v-model="bilanciMinisteroActiveData.prevUtenze"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Utenze"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevPulizieGestSpazi" class="h5">Pulizie Gestione Spazi</label>
                          <ejs-numerictextbox
                            id="prevPulizieGestSpazi"
                            v-model="bilanciMinisteroActiveData.prevPulizieGestSpazi"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Pulizie Gestione Spazi"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevQuotaAmmSceneCostumi" class="h5"
                            >Quota amm.to scene/costumi</label
                          >
                          <ejs-numerictextbox
                            id="prevQuotaAmmSceneCostumi"
                            v-model="
                              bilanciMinisteroActiveData.prevQuotaAmmSceneCostumi
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Quota amm.to scene/costumi"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevQuotaAmmStrumentTecnica" class="h5"
                            >Quota amm.to strumentazione tecnica</label
                          >
                          <ejs-numerictextbox
                            id="prevQuotaAmmStrumentTecnica"
                            v-model="
                              bilanciMinisteroActiveData.prevQuotaAmmStrumentTecnica
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Quota amm.to strumentazione tecnica"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevMaterialeConsumo" class="h5"
                            >Materiale di consumo</label
                          >
                          <ejs-numerictextbox
                            id="prevMaterialeConsumo"
                            v-model="
                              bilanciMinisteroActiveData.prevMaterialeConsumo
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Materiale di consumo"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAffittoUffici" class="h5"
                            >Affitto uffici</label
                          >
                          <ejs-numerictextbox
                            id="prevAffittoUffici"
                            v-model="
                              bilanciMinisteroActiveData.prevAffittoUffici
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Affitto uffici"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="prevAltrePrestazioniProfessionali"
                            class="h5"
                            >Altre prestazioni Professionali</label
                          >
                          <ejs-numerictextbox
                            id="prevAltrePrestazioniProfessionali"
                            v-model="
                              bilanciMinisteroActiveData.prevAltrePrestazioniProfessionali
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altre prestazioni Professionali (commercialista, consulente lavoro, avvocato, RSPP ecc)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevUtenzeUffici" class="h5"
                            >Utenze uffici</label
                          >
                          <ejs-numerictextbox
                            id="prevUtenzeUffici"
                            v-model="
                              bilanciMinisteroActiveData.prevUtenzeUffici
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Utenze uffici"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAssicurazioni" class="h5"
                            >Assicurazioni</label
                          >
                          <ejs-numerictextbox
                            id="prevAssicurazioni"
                            v-model="
                              bilanciMinisteroActiveData.prevAssicurazioni
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Assicurazioni"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevPulizieGenerali" class="h5">Pulizie Generali</label>
                          <ejs-numerictextbox
                            id="prevPulizieGenerali"
                            v-model="bilanciMinisteroActiveData.prevPulizieGenerali"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Pulizie Generali"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAltriCostiGenerali" class="h5"
                            >Altri costi Generali (Diritti ecc)</label
                          >
                          <ejs-numerictextbox
                            id="prevAltriCostiGenerali"
                            v-model="
                              bilanciMinisteroActiveData.prevAltriCostiGenerali
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altri costi Generali (Diritti ecc)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCostiTutelaSanitaria" class="h5"
                            >Costi tutela sanitaria</label
                          >
                          <ejs-numerictextbox
                            id="prevCostiTutelaSanitaria"
                            v-model="
                              bilanciMinisteroActiveData.prevCostiTutelaSanitaria
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi tutela sanitaria"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>

                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevTotaleUscite" class="h5"
                            >TOTALE USCITE BILANCIO PREVENTIVO</label
                          >
                          <ejs-numerictextbox
                            id="prevTotaleUscite"
                            v-model="prevTotaleUscite"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Totale Uscite"
                            showSpinButton="false"
                            showClearButton="true"
                            :readonly="true"
                          />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>DEFICIT BILANCIO PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title></b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevDeficit" class="h5"
                            >DEFICIT BILANCIO PREVENTIVO</label
                          >
                          <ejs-numerictextbox
                            id="prevDeficit"
                            v-model="prevDeficit"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Deficit"
                            showSpinButton="false"
                            showClearButton="true"
                            :readonly="true"
                          />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              title="BILANCIO MINISTERO CONSUNTIVO"
              @click="tabClicked('tab02')"
            >
              <b-row class="match-height">
                <b-col xl="12" md="12">
                  <h3>&nbsp</h3>
                  <h3>ENTRATE BILANCIO CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Entrate</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrStataliExtraFUS" class="h5"
                            >Contributi Statali (extra FUS)</label
                          >
                          <ejs-numerictextbox
                            id="consContrStataliExtraFUS"
                            v-model="
                              bilanciMinisteroActiveData.consContrStataliExtraFUS
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi Statali (extra FUS)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrRegionali" class="h5"
                            >Contributi regionali</label
                          >
                          <ejs-numerictextbox
                            id="consContrRegionali"
                            v-model="
                              bilanciMinisteroActiveData.consContrRegionali
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi regionali"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrComunali" class="h5"
                            >Contributi comunali</label
                          >
                          <ejs-numerictextbox
                            id="consContrComunali"
                            v-model="
                              bilanciMinisteroActiveData.consContrComunali
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi comunali"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrUE" class="h5"
                            >Contributi da UE</label
                          >
                          <ejs-numerictextbox
                            id="consContrUE"
                            v-model="bilanciMinisteroActiveData.consContrUE"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi da UE"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrAltriEntiPubblici" class="h5"
                            >Contributi da altri enti pubblici</label
                          >
                          <ejs-numerictextbox
                            id="consContrAltriEntiPubblici"
                            v-model="
                              bilanciMinisteroActiveData.consContrAltriEntiPubblici
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi da altri enti pubblici"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrSoggettiPrivati" class="h5"
                            >Contributi da soggetti privati</label
                          >
                          <ejs-numerictextbox
                            id="consContrSoggettiPrivati"
                            v-model="
                              bilanciMinisteroActiveData.consContrSoggettiPrivati
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Contributi da soggetti privati"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSponsorEconomiche" class="h5"
                            >Sponsorizzazioni economiche</label
                          >
                          <ejs-numerictextbox
                            id="consSponsorEconomiche"
                            v-model="
                              bilanciMinisteroActiveData.consSponsorEconomiche
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Sponsorizzazioni economiche"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRimborsiCoproduzione" class="h5"
                            >Rimborsi da coproduzione</label
                          >
                          <ejs-numerictextbox
                            id="consRimborsiCoproduzione"
                            v-model="
                              bilanciMinisteroActiveData.consRimborsiCoproduzione
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Rimborsi da coproduzione"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAltreEntrateCoproduzione" class="h5"
                            >Altre entrate da coproduzione</label
                          >
                          <ejs-numerictextbox
                            id="consAltreEntrateCoproduzione"
                            v-model="
                              bilanciMinisteroActiveData.consAltreEntrateCoproduzione
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altre entrate da coproduzione"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consEntrateAbbonamenti" class="h5"
                            >Entrate da abbonamenti</label
                          >
                          <ejs-numerictextbox
                            id="consEntrateAbbonamenti"
                            v-model="
                              bilanciMinisteroActiveData.consEntrateAbbonamenti
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Entrate da abbonamenti"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consIncassiBiglietteriaProdCoprod"
                            class="h5"
                            >Incassi da biglietteria (produz. E co-prod)</label
                          >
                          <ejs-numerictextbox
                            id="consIncassiBiglietteriaProdCoprod"
                            v-model="
                              bilanciMinisteroActiveData.consIncassiBiglietteriaProdCoprod
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Incassi da biglietteria (produz. E co-prod)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consIncassiBiglietteriaOspitalita"
                            class="h5"
                            >Incassi da biglietteria (ospitalità)</label
                          >
                          <ejs-numerictextbox
                            id="consIncassiBiglietteriaOspitalita"
                            v-model="
                              bilanciMinisteroActiveData.consIncassiBiglietteriaOspitalita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Incassi da biglietteria (ospitalità)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consIncassiPrevendita" class="h5"
                            >Incassi da prevendita</label
                          >
                          <ejs-numerictextbox
                            id="consIncassiPrevendita"
                            v-model="
                              bilanciMinisteroActiveData.consIncassiPrevendita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Incassi da consendita"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consEntrateCompensiAttivita" class="h5"
                            >Entrate derivanti da compensi per attività</label
                          >
                          <ejs-numerictextbox
                            id="consEntrateCompensiAttivita"
                            v-model="
                              bilanciMinisteroActiveData.consEntrateCompensiAttivita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Entrate derivanti da compensi per attività"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consAltreEntrateAttivitaCaratteristica"
                            class="h5"
                            >Altre entrate da Attività Caratteristica</label
                          >
                          <ejs-numerictextbox
                            id="consAltreEntrateAttivitaCaratteristica"
                            v-model="
                              bilanciMinisteroActiveData.consAltreEntrateAttivitaCaratteristica
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altre entrate da Attività Caratteristica"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consEntrateServiziAccessori" class="h5"
                            >Entrate da servizi accessori</label
                          >
                          <ejs-numerictextbox
                            id="consEntrateServiziAccessori"
                            v-model="
                              bilanciMinisteroActiveData.consEntrateServiziAccessori
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Entrate da servizi accessori"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAltreEntrateAltreAttivita" class="h5"
                            >Altre entrate (es quote sociali)</label
                          >
                          <ejs-numerictextbox
                            id="consAltreEntrateAltreAttivita"
                            v-model="
                              bilanciMinisteroActiveData.consAltreEntrateAltreAttivita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altre entrate (es quote sociali)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>

                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consTotaleEntrate" class="h5"
                            >TOTALE ENTRATE BILANCIO CONSUNTIVO</label
                          >
                          <ejs-numerictextbox
                            id="consTotaleEntrate"
                            v-model="consTotaleEntrate"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Totale Entrate"
                            showSpinButton="false"
                            showClearButton="true"
                            :readonly="true"
                          />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>USCITE BILANCIO CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Uscite</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consOneriSocialiDirettoreArtisticoCaricoA"
                            class="h5"
                            >Oneri sociali direttore artistico carico A.</label
                          >
                          <ejs-numerictextbox
                            id="consOneriSocialiDirettoreArtisticoCaricoA"
                            v-model="
                              bilanciMinisteroActiveData.consOneriSocialiDirettoreArtisticoCaricoA
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Oneri sociali direttore artistico carico A."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCompensoDirettoreArtistico" class="h5"
                            >Compenso direttore artistico</label
                          >
                          <ejs-numerictextbox
                            id="consCompensoDirettoreArtistico"
                            v-model="
                              bilanciMinisteroActiveData.consCompensoDirettoreArtistico
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Compenso direttore artistico"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consRetribuzioneLordaPersonaleArtistico"
                            class="h5"
                            >Retribuzione lorda personale artistico</label
                          >
                          <ejs-numerictextbox
                            id="consRetribuzioneLordaPersonaleArtistico"
                            v-model="
                              bilanciMinisteroActiveData.consRetribuzioneLordaPersonaleArtistico
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Retribuzione lorda personale artistico"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consOneriSocialiPersonaleArtisticoCaricoA"
                            class="h5"
                            >Oneri sociali personale artistico carico A.</label
                          >
                          <ejs-numerictextbox
                            id="consOneriSocialiPersonaleArtisticoCaricoA"
                            v-model="
                              bilanciMinisteroActiveData.consOneriSocialiPersonaleArtisticoCaricoA
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Oneri sociali personale artistico carico A."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consRetribuzioneLordaPersonaleTecnico"
                            class="h5"
                            >Retribuzione lorda personale tecnico</label
                          >
                          <ejs-numerictextbox
                            id="consRetribuzioneLordaPersonaleTecnico"
                            v-model="
                              bilanciMinisteroActiveData.consRetribuzioneLordaPersonaleTecnico
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Retribuzione lorda personale tecnico"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consOneriSocialiPersonaleTecnicoCaricoA"
                            class="h5"
                            >Oneri sociali personale tecnico carico A.</label
                          >
                          <ejs-numerictextbox
                            id="consOneriSocialiPersonaleTecnicoCaricoA"
                            v-model="
                              bilanciMinisteroActiveData.consOneriSocialiPersonaleTecnicoCaricoA
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Oneri sociali personale tecnico carico A."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consRetribuzioneLordaPersonaleAmm"
                            class="h5"
                            >Retribuzione lorda personale amm.vo</label
                          >
                          <ejs-numerictextbox
                            id="consRetribuzioneLordaPersonaleAmm"
                            v-model="
                              bilanciMinisteroActiveData.consRetribuzioneLordaPersonaleAmm
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Retribuzione lorda personale amm.vo"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consOneriSocialiPersonaleAmmCaricoA"
                            class="h5"
                            >Oneri sociali personale amm.vo carico A.</label
                          >
                          <ejs-numerictextbox
                            id="consOneriSocialiPersonaleAmmCaricoA"
                            v-model="
                              bilanciMinisteroActiveData.consOneriSocialiPersonaleAmmCaricoA
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Oneri sociali personale amm.vo carico A."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consDiarieForfettarie" class="h5"
                            >Diarie forfettarie</label
                          >
                          <ejs-numerictextbox
                            id="consDiarieForfettarie"
                            v-model="
                              bilanciMinisteroActiveData.consDiarieForfettarie
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Diarie forfettarie"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCompensiOrganismiOspitati" class="h5"
                            >Compensi organismi ospitati</label
                          >
                          <ejs-numerictextbox
                            id="consCompensiOrganismiOspitati"
                            v-model="
                              bilanciMinisteroActiveData.consCompensiOrganismiOspitati
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Compensi organismi ospitati"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consCostiViaggiTrasportoAlloggiCO"
                            class="h5"
                            >Costi viaggi, trasporto, alloggi C.O.</label
                          >
                          <ejs-numerictextbox
                            id="consCostiViaggiTrasportoAlloggiCO"
                            v-model="
                              bilanciMinisteroActiveData.consCostiViaggiTrasportoAlloggiCO
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi viaggi, trasporto, alloggi C.O."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consNoleggiTecniciOsp" class="h5"
                            >Noleggi tecnici ospitalità</label
                          >
                          <ejs-numerictextbox
                            id="consNoleggiTecniciOsp"
                            v-model="
                              bilanciMinisteroActiveData.consNoleggiTecniciOsp
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Noleggi tecnici"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consPrestazioniTerziAllestimentiOsp"
                            class="h5"
                            >Prestazioni di terzi x allestimenti(m/s/f) ospitalità</label
                          >
                          <ejs-numerictextbox
                            id="consPrestazioniTerziAllestimentiOsp"
                            v-model="
                              bilanciMinisteroActiveData.consPrestazioniTerziAllestimentiOsp
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Prestazioni di terzi x allestimenti(m/s/f)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSIAEOsp" class="h5"
                            >SIAE Ospitalità</label
                          >
                          <ejs-numerictextbox
                            id="consSIAEOsp"
                            v-model="bilanciMinisteroActiveData.consSIAEOsp"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="SIAE Ospitalità"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consVVFCaricoAziendaOsp" class="h5"
                            >VVF a carico azienda Ospitalità</label
                          >
                          <ejs-numerictextbox
                            id="consVVFCaricoAziendaOsp"
                            v-model="
                              bilanciMinisteroActiveData.consVVFCaricoAziendaOsp
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="VVF a carico azienda Ospitalità"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consCostiViaggiTrasportoAlloggiProduzioni"
                            class="h5"
                            >Costi viaggi, trasporto, alloggi Produzioni</label
                          >
                          <ejs-numerictextbox
                            id="consCostiViaggiTrasportoAlloggiProduzioni"
                            v-model="
                              bilanciMinisteroActiveData.consCostiViaggiTrasportoAlloggiProduzioni
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi viaggi, trasporto, alloggi Produzioni"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consAcquistiSceneCostumiStrumentiProd"
                            class="h5"
                            >Acquisti scene, costumi,strumenti ecc</label
                          >
                          <ejs-numerictextbox
                            id="consAcquistiSceneCostumiStrumentiProd"
                            v-model="
                              bilanciMinisteroActiveData.consAcquistiSceneCostumiStrumentiProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Acquisti scene, costumi,strumenti ecc"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consNoleggiSceneCostumiStrumentiProd"
                            class="h5"
                            >Noleggi scene, costumi,strumenti ecc</label
                          >
                          <ejs-numerictextbox
                            id="consNoleggiSceneCostumiStrumentiProd"
                            v-model="
                              bilanciMinisteroActiveData.consNoleggiSceneCostumiStrumentiProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Noleggi scene, costumi,strumenti ecc"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consAcquistiStrumentazioneTecnicaNonAmmProd"
                            class="h5"
                            >Acquisti strumentazione tecnica non amm.</label
                          >
                          <ejs-numerictextbox
                            id="consAcquistiStrumentazioneTecnicaNonAmmProd"
                            v-model="
                              bilanciMinisteroActiveData.consAcquistiStrumentazioneTecnicaNonAmmProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Acquisti strumentazione tecnica non amm."
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consNoleggiStrumentazioneTecnicaProd"
                            class="h5"
                            >Noleggi strumentazione tecnica</label
                          >
                          <ejs-numerictextbox
                            id="consNoleggiStrumentazioneTecnicaProd"
                            v-model="
                              bilanciMinisteroActiveData.consNoleggiStrumentazioneTecnicaProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Noleggi strumentazione tecnica"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAffittoSalaProveProd" class="h5"
                            >Affitto sala prove</label
                          >
                          <ejs-numerictextbox
                            id="consAffittoSalaProveProd"
                            v-model="
                              bilanciMinisteroActiveData.consAffittoSalaProveProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Affitto sala prove"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consPrestazioniTerziAllestimentiProd"
                            class="h5"
                            >Prestazioni di terzi x allestimenti(m/s/f)</label
                          >
                          <ejs-numerictextbox
                            id="consPrestazioniTerziAllestimentiProd"
                            v-model="
                              bilanciMinisteroActiveData.consPrestazioniTerziAllestimentiProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Prestazioni di terzi x allestimenti(m/s/f)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSIAEProd" class="h5"
                            >SIAE Produzioni</label
                          >
                          <ejs-numerictextbox
                            id="consSIAEProd"
                            v-model="bilanciMinisteroActiveData.consSIAEProd"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="SIAE Produzioni"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consVVFCaricoAziendaProd" class="h5"
                            >VVF a carico azienda Produzioni</label
                          >
                          <ejs-numerictextbox
                            id="consVVFCaricoAziendaProd"
                            v-model="
                              bilanciMinisteroActiveData.consVVFCaricoAziendaProd
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="VVF a carico azienda Produzioni"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consUfficioStampaComunicazione" class="h5"
                            >Ufficio stampa e comunicazione</label
                          >
                          <ejs-numerictextbox
                            id="consUfficioStampaComunicazione"
                            v-model="
                              bilanciMinisteroActiveData.consUfficioStampaComunicazione
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Ufficio stampa e comunicazione"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consCostiStampeDistribAffissione"
                            class="h5"
                            >Costi stampe,distrib. E affissione</label
                          >
                          <ejs-numerictextbox
                            id="consCostiStampeDistribAffissione"
                            v-model="
                              bilanciMinisteroActiveData.consCostiStampeDistribAffissione
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi stampe,distrib. E affissione"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCostiPrestazioniPubblProm" class="h5"
                            >Costi per prestazioni (registr., video, ..)</label
                          >
                          <ejs-numerictextbox
                            id="consCostiPrestazioniPubblProm"
                            v-model="
                              bilanciMinisteroActiveData.consCostiPrestazioniPubblProm
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi per prestazioni (registr., video, audio, foto)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCostiPubblicita" class="h5"
                            >Costi per pubblicità</label
                          >
                          <ejs-numerictextbox
                            id="consCostiPubblicita"
                            v-model="
                              bilanciMinisteroActiveData.consCostiPubblicita
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi per pubblicità"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCostiGestioneManSitoWeb" class="h5"
                            >Costi gestione e man.ne sito web</label
                          >
                          <ejs-numerictextbox
                            id="consCostiGestioneManSitoWeb"
                            v-model="
                              bilanciMinisteroActiveData.consCostiGestioneManSitoWeb
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi gestione e man.ne sito web"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCostiPromoPiattDig" class="h5"
                            >Costi promozione piattaforme digitali</label
                          >
                          <ejs-numerictextbox
                            id="consCostiPromoPiattDig"
                            v-model="
                              bilanciMinisteroActiveData.consCostiPromoPiattDig
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi promozione piattaforme digitali"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAffittoSpaziSpettacoli" class="h5"
                            >Affitto spazi per spettacoli</label
                          >
                          <ejs-numerictextbox
                            id="consAffittoSpaziSpettacoli"
                            v-model="
                              bilanciMinisteroActiveData.consAffittoSpaziSpettacoli
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Affitto spazi per spettacoli"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCostiManOrdinariaSpazi" class="h5"
                            >Costi di manutenzione ordinaria spazi</label
                          >
                          <ejs-numerictextbox
                            id="consCostiManOrdinariaSpazi"
                            v-model="
                              bilanciMinisteroActiveData.consCostiManOrdinariaSpazi
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi di manutenzione ordinaria spazi"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consUtenze" class="h5">Utenze</label>
                          <ejs-numerictextbox
                            id="consUtenze"
                            v-model="bilanciMinisteroActiveData.consUtenze"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Utenze"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consPulizieGestSpazi" class="h5">Pulizie Gestione Spazi</label>
                          <ejs-numerictextbox
                            id="consPulizieGestSpazi"
                            v-model="bilanciMinisteroActiveData.consPulizieGestSpazi"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Pulizie Gestione Spazi"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consQuotaAmmSceneCostumi" class="h5"
                            >Quota amm.to scene/costumi</label
                          >
                          <ejs-numerictextbox
                            id="consQuotaAmmSceneCostumi"
                            v-model="
                              bilanciMinisteroActiveData.consQuotaAmmSceneCostumi
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Quota amm.to scene/costumi"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consQuotaAmmStrumentTecnica" class="h5"
                            >Quota amm.to strumentazione tecnica</label
                          >
                          <ejs-numerictextbox
                            id="consQuotaAmmStrumentTecnica"
                            v-model="
                              bilanciMinisteroActiveData.consQuotaAmmStrumentTecnica
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Quota amm.to strumentazione tecnica"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consMaterialeConsumo" class="h5"
                            >Materiale di consumo</label
                          >
                          <ejs-numerictextbox
                            id="consMaterialeConsumo"
                            v-model="
                              bilanciMinisteroActiveData.consMaterialeConsumo
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Materiale di consumo"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAffittoUffici" class="h5"
                            >Affitto uffici</label
                          >
                          <ejs-numerictextbox
                            id="consAffittoUffici"
                            v-model="
                              bilanciMinisteroActiveData.consAffittoUffici
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Affitto uffici"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label
                            for="consAltrePrestazioniProfessionali"
                            class="h5"
                            >Altre prestazioni Professionali</label
                          >
                          <ejs-numerictextbox
                            id="consAltrePrestazioniProfessionali"
                            v-model="
                              bilanciMinisteroActiveData.consAltrePrestazioniProfessionali
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altre prestazioni Professionali (commercialista, consulente lavoro, avvocato, RSPP ecc)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consUtenzeUffici" class="h5"
                            >Utenze uffici</label
                          >
                          <ejs-numerictextbox
                            id="consUtenzeUffici"
                            v-model="
                              bilanciMinisteroActiveData.consUtenzeUffici
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Utenze uffici"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAssicurazioni" class="h5"
                            >Assicurazioni</label
                          >
                          <ejs-numerictextbox
                            id="consAssicurazioni"
                            v-model="
                              bilanciMinisteroActiveData.consAssicurazioni
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Assicurazioni"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consPulizieGenerali" class="h5">Pulizie Generali</label>
                          <ejs-numerictextbox
                            id="consPulizieGenerali"
                            v-model="bilanciMinisteroActiveData.consPulizieGenerali"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Pulizie Generali"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAltriCostiGenerali" class="h5"
                            >Altri costi Generali (Diritti ecc)</label
                          >
                          <ejs-numerictextbox
                            id="consAltriCostiGenerali"
                            v-model="
                              bilanciMinisteroActiveData.consAltriCostiGenerali
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Altri costi Generali (Diritti ecc)"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCostiTutelaSanitaria" class="h5"
                            >Costi tutela sanitaria</label
                          >
                          <ejs-numerictextbox
                            id="consCostiTutelaSanitaria"
                            v-model="
                              bilanciMinisteroActiveData.consCostiTutelaSanitaria
                            "
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Costi tutela sanitaria"
                            showSpinButton="false"
                            showClearButton="true"
                          />
                        </b-col>

                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consTotaleUscite" class="h5"
                            >TOTALE USCITE BILANCIO CONSUNTIVO</label
                          >
                          <ejs-numerictextbox
                            id="consTotaleUscite"
                            v-model="consTotaleUscite"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Totale Uscite"
                            showSpinButton="false"
                            showClearButton="true"
                            :readonly="true"
                          />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>DEFICIT BILANCIO CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title></b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consDeficit" class="h5"
                            >DEFICIT BILANCIO CONSUNTIVO</label
                          >
                          <ejs-numerictextbox
                            id="consDeficit"
                            v-model="consDeficit"
                            floatLabelType="Never"
                            cssClass=""
                            format="€ ###.##"
                            placeholder="Deficit"
                            showSpinButton="false"
                            showClearButton="true"
                            :readonly="true"
                          />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
      <b-col xl="12" md="12" class="text-right mt-1" v-show="showTabsBilancio">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title></b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <b-row>
              <b-col xl="4" md="4">
                <ejs-button
                  id="creaBilancioMinisteroButton"
                  cssClass="e-flat"
                  @click.native="salvaBilancioMinisteroButton()"
                  >SALVA IL BILANCIO CORRENTE
                </ejs-button>
              </b-col>
              <b-col xl="4" md="4">
                <ejs-button
                  id="importaVociRegContabiliButton"
                  cssClass="e-flat"
                  @click.native="importaVociRegContabili()"
                  >IMPORTA VOCI CONSUNTIVO DA REG. CONTABILI
                </ejs-button>
              </b-col>
              <b-col xl="4" md="4">
                <ejs-button
                  id="exportaVociRegContabiliButton"
                  cssClass="e-flat"
                  @click.native="esportaVociRegContabili()"
                  >ESPORTA BILANCIO IN EXCEL
                </ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Aggregate,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;
const apibilanciMinisteroUrl = "/demo/api/bilancioministero";
const apibilancioMinisteroRicercaUrl = "/demo/api/bilancioministero/ricercaanno";
const apiExportBilancioMinisteroUrl = "/demo/api/bilancioministero/export_bilancio_ministero_xls"
const apiImportBilancioMinisteroUrl = "/demo/api/bilancioministero/import_bilancio_ministero"

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      loading: false,
      // per gestione anni
      anniData: [
        { label: "Anno 2019", val: "2019" },
        { label: "Anno 2020", val: "2020" },
        { label: "Anno 2021", val: "2021" },  
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
        { label: "Anno 2027", val: "2027" },
      ],
      anniFields: { value: "val", text: "label" },
      anniIndex: -1,
      queryAnni: null,
      annoCorrente: null,

      // gestione elementi nascosti
      nonMostrare: false,
      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
        firstDayOfWeek: 1,
      },
      // bilanciMinistero
      bilanciMinisteroFullData: [], // elenco completo dati bilanciMinistero
      bilanciMinisteroActiveId: 0, // Id bilancioMinistero attivo (0 se nuovo)
      bilanciMinisteroActiveData: {}, // dati completi del bilancioMinistero attivo
      bilanciMinisteroSavedData: {}, // dati completi del bilancioMinistero attivo
      bilanciMinisteroDefaultData: {}, // dati completi di default per nuovi bilanciMinistero

      // fornitori
      fornitoriList: [],
      fornitoriFields: { text: "ragioneSociale", value: "id" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per bottoneCreazioneBilancio
      showButtonCreateBilancio: false,

      // per tabA
      tabAIndex: null,

      // per showTabsBilancio
      showTabsBilancio: false,
    };
  },
  created() {
    // log
    console.log("Pagina bilanciMinistero Creata");
    // inizializzazione elenchi dal backend
    // chiamate API

    // TODO gestione status 401 con redirect a login
    if (localStorage.getItem("userData") !== null) {
      // bilanciMinisteroNazionalità e bilanciMinisteroRuoli
      console.log("Recupero elenchi dal backend");

      // bilanciMinisteroFullData
      // recupero elenco bilanciMinistero dal backend
      console.log("Recupero elenco bilanciMinistero dal backend");
    } else {
      console.log("Non trovo UserData, prova ancora");
    }
  },
  mounted() {
    // focus su dropAnni
    this.$refs.dropAnni.ej2Instances.focusIn();
  },

  provide: {
    // per grid
    grid: [
      GridToolbar,
      GridSort,
      GridFilter,
      GridEdit,
      ForeignKey,
      Group,
      Aggregate,
    ],
  },
  methods: {
    creaBilancioMinisteroButton: function () {
      console.log("Creazione nuovo Bilancio Ministero");

      // salvataggio in caso di new

      this.bilanciMinisteroActiveData = { id: 0, anno: this.annoCorrente };

      useJwt
        .post(apibilanciMinisteroUrl, this.bilanciMinisteroActiveData)
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            this.makeToast(
              "primary",
              "Successo",
              "Creazione del bilancioMinistero"
            );
          }
          console.log(res.status);
          console.log(res.data);
          // mi segno ID elemento appena creato
          this.bilanciMinisteroActiveId = res.data.id;
          return this; // restituisci contesto per permettere aggiornamento gridA
        });
      // .then((context) => {
      //   useJwt.get(apibilanciMinisteroUrl).then((d) => {
      //     // gestione risposta
      //     console.log("Aggiornamento gridA con l'aggiunta di una scrittura");
      //     console.log(d.data);
      //     context.bilanciMinisteroFullData = d.data;
      //     context.bilanciMinisteroFullData = [
      //       ...context.bilanciMinisteroFullData,
      //     ];
      //   });
      // });

      this.showButtonCreateBilancio = false;
    },
    salvaBilancioMinisteroButton: function () {
      console.log("Salvataggio in Edit Bilancio Ministero");

      // salvataggio in caso di edit

      // salvo i field computed
      this.bilanciMinisteroActiveData.prevTotaleEntrate =
        this.prevTotaleEntrate;
      this.bilanciMinisteroActiveData.prevTotaleUscite = this.prevTotaleUscite;
      this.bilanciMinisteroActiveData.prevDeficit = this.prevDeficit;
      this.bilanciMinisteroActiveData.consTotaleEntrate =
        this.consTotaleEntrate;
      this.bilanciMinisteroActiveData.consTotaleUscite = this.consTotaleUscite;
      this.bilanciMinisteroActiveData.consDeficit = this.consDeficit;

      //this.bilanciMinisteroActiveData = { id: 0, anno: this.annoCorrente };
      const editUrl = `${apibilanciMinisteroUrl}/${this.bilanciMinisteroActiveId}`;

      this.bilanciMinisteroActiveData['anno'] = this.annoCorrente
      useJwt.patch(editUrl, this.bilanciMinisteroActiveData).then((res) => {
        if (res.status == 200 || res.status == 201) {
          this.makeToast(
            "primary",
            "Successo",
            "Modifica del bilancio ministero eseguita con successo"
          );
        } else {
          this.makeToast(
            "primary",
            "ERRORE",
            "Errore nel salvataggio bilancio ministero"
          );

        }
        console.log(res.status);
        console.log(res.data);
        // mi segno ID elemento appena creato
        this.bilanciMinisteroActiveId = res.data.id;
        return this; // restituisci contesto per permettere aggiornamento gridA
      });
      // .then((context) => {
      //   useJwt.get(apibilanciMinisteroUrl).then((d) => {
      //     // gestione risposta
      //     console.log("Aggiornamento gridA con l'aggiunta di una scrittura");
      //     console.log(d.data);
      //     context.bilanciMinisteroFullData = d.data;
      //     context.bilanciMinisteroFullData = [
      //       ...context.bilanciMinisteroFullData,
      //     ];
      //   });
      // });

      this.showButtonCreateBilancio = false;
    },
    importaVociRegContabili: function() {
      const datiDaInviare = {
        anno: this.annoCorrente,
      }

      useJwt.post(apiImportBilancioMinisteroUrl, datiDaInviare).then((r)=>{
        console.log(r.data)
        this.bilanciMinisteroActiveData = r.data
      })
    },
    esportaVociRegContabili: function () {
      this.bilanciMinisteroActiveData['anno'] = this.annoCorrente

      useJwt.post(apiExportBilancioMinisteroUrl, this.bilanciMinisteroActiveData, { responseType: "blob" }).then((r)=>{
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "bilancio_ministero_entrate_uscite.xlsx");
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore generazione excel")
      });
    },
    // onAnnoChange
    onAnnoChange: function (e) {
      this.loading = true;
      console.log("Recupero elenco bilanci Ministero dal backend");
      const datiDaInviare = {
        anno: this.annoCorrente,
      };
      if (datiDaInviare.anno === null) {
        console.log("Anno non ancora selezionato");
      } else {
        // recupero il bilancio ministero salvato con quell'anno se esistente
        useJwt.post(apibilancioMinisteroRicercaUrl, datiDaInviare).then((d) => {
          // gestione risposta
          //this.bilanciMinisteroActiveData = d.data;
          console.log("Bilancio Ministero collegato:");
          //console.log(this.bilanciMinisteroActiveData);
          //console.log(this.bilanciMinisteroActiveData.length);
          this.loading = false;
          if (d.data.length == 0) {
            console.log(
              "Non esiste ancora un bilancio ministero per l'anno selezionato"
            );
            this.bilanciMinisteroActiveData = {};
            // disabilito tabs e abilito bottone create
            this.showTabsBilancio = false;
            this.showButtonCreateBilancio = true;
          } else {
            this.bilanciMinisteroActiveData = d.data[0];
            this.bilanciMinisteroActiveId = d.data[0].id;
            // abilito tabs e disabilito bottone create
            this.showTabsBilancio = true;
            this.showButtonCreateBilancio = false;
            console.log("bilanciMinisteroActiveData");
            console.log(this.bilanciMinisteroActiveData);
            console.log(this.bilanciMinisteroActiveData.anno);

            // context.bilanciMinisteroFullData = d.data;
            // context.bilanciMinisteroFullData = [
            //   ...context.bilanciMinisteroFullData,
            // ];
          }
        });
      }
    },

    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "tab01":
          console.log("Sei nel primo tab");
          break;
        case "tab02":
          console.log("Sei nel secondo tab");
          break;
        default:
          console.log(args);
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
  computed: {
    hasChanged() {
      // console.log(this.bilanciMinisteroActiveData)
      // console.log(this.bilanciMinisteroSavedData)
      return Object.keys(this.bilanciMinisteroActiveData).some(
        (field) =>
          this.bilanciMinisteroActiveData[field] !==
          this.bilanciMinisteroSavedData[field]
      );
    },
    prevTotaleEntrate: {
      get: function () {
        return (
            this.bilanciMinisteroActiveData.prevContrStataliExtraFUS +
            this.bilanciMinisteroActiveData.prevContrRegionali +
            this.bilanciMinisteroActiveData.prevContrComunali +
            this.bilanciMinisteroActiveData.prevContrUE +
            this.bilanciMinisteroActiveData.prevContrAltriEntiPubblici +
            this.bilanciMinisteroActiveData.prevContrSoggettiPrivati +
            this.bilanciMinisteroActiveData.prevSponsorEconomiche +
            this.bilanciMinisteroActiveData.prevRimborsiCoproduzione +
            this.bilanciMinisteroActiveData.prevAltreEntrateCoproduzione +
            this.bilanciMinisteroActiveData.prevEntrateAbbonamenti +
            this.bilanciMinisteroActiveData.prevIncassiBiglietteriaProdCoprod +
            this.bilanciMinisteroActiveData.prevIncassiBiglietteriaOspitalita +
            this.bilanciMinisteroActiveData.prevIncassiPrevendita +
            this.bilanciMinisteroActiveData.prevEntrateCompensiAttivita +
            this.bilanciMinisteroActiveData.prevAltreEntrateAttivitaCaratteristica +
            this.bilanciMinisteroActiveData.prevEntrateServiziAccessori +
            this.bilanciMinisteroActiveData.prevAltreEntrateAltreAttivita
        );
      },
      set: function () {
        // non usato
      },
    },
    prevTotaleUscite: {
      get: function () {
        return (
          this.bilanciMinisteroActiveData.prevOneriSocialiDirettoreArtisticoCaricoA +
          this.bilanciMinisteroActiveData.prevCompensoDirettoreArtistico +
          this.bilanciMinisteroActiveData.prevRetribuzioneLordaPersonaleArtistico +
          this.bilanciMinisteroActiveData.prevOneriSocialiPersonaleArtisticoCaricoA +
          this.bilanciMinisteroActiveData.prevRetribuzioneLordaPersonaleTecnico +
          this.bilanciMinisteroActiveData.prevOneriSocialiPersonaleTecnicoCaricoA +
          this.bilanciMinisteroActiveData.prevRetribuzioneLordaPersonaleAmm +
          this.bilanciMinisteroActiveData.prevOneriSocialiPersonaleAmmCaricoA +
          this.bilanciMinisteroActiveData.prevDiarieForfettarie +
          this.bilanciMinisteroActiveData.prevCompensiOrganismiOspitati +
          this.bilanciMinisteroActiveData.prevCostiViaggiTrasportoAlloggiCO +
          this.bilanciMinisteroActiveData.prevNoleggiTecniciOsp +
          this.bilanciMinisteroActiveData.prevPrestazioniTerziAllestimentiOsp +
          this.bilanciMinisteroActiveData.prevSIAEOsp +
          this.bilanciMinisteroActiveData.prevVVFCaricoAziendaOsp +
          this.bilanciMinisteroActiveData.prevCostiViaggiTrasportoAlloggiProduzioni +
          this.bilanciMinisteroActiveData.prevAcquistiSceneCostumiStrumentiProd +
          this.bilanciMinisteroActiveData.prevNoleggiSceneCostumiStrumentiProd +
          this.bilanciMinisteroActiveData.prevAcquistiStrumentazioneTecnicaNonAmmProd +
          this.bilanciMinisteroActiveData.prevNoleggiStrumentazioneTecnicaProd +
          this.bilanciMinisteroActiveData.prevAffittoSalaProveProd +
          this.bilanciMinisteroActiveData.prevPrestazioniTerziAllestimentiProd +
          this.bilanciMinisteroActiveData.prevSIAEProd +
          this.bilanciMinisteroActiveData.prevVVFCaricoAziendaProd +
          this.bilanciMinisteroActiveData.prevUfficioStampaComunicazione +
          this.bilanciMinisteroActiveData.prevCostiStampeDistribAffissione +
          this.bilanciMinisteroActiveData.prevCostiPrestazioniPubblProm +
          this.bilanciMinisteroActiveData.prevCostiPubblicita +
          this.bilanciMinisteroActiveData.prevCostiGestioneManSitoWeb +
          this.bilanciMinisteroActiveData.prevCostiPromoPiattDig +
          this.bilanciMinisteroActiveData.prevAffittoSpaziSpettacoli +
          this.bilanciMinisteroActiveData.prevCostiManOrdinariaSpazi +
          this.bilanciMinisteroActiveData.prevUtenze +
          this.bilanciMinisteroActiveData.prevPulizieGestSpazi +
          this.bilanciMinisteroActiveData.prevQuotaAmmSceneCostumi +
          this.bilanciMinisteroActiveData.prevQuotaAmmStrumentTecnica +
          this.bilanciMinisteroActiveData.prevMaterialeConsumo +
          this.bilanciMinisteroActiveData.prevAffittoUffici +
          this.bilanciMinisteroActiveData.prevAltrePrestazioniProfessionali +
          this.bilanciMinisteroActiveData.prevUtenzeUffici +
          this.bilanciMinisteroActiveData.prevAssicurazioni +
          this.bilanciMinisteroActiveData.prevPulizieGenerali +
          this.bilanciMinisteroActiveData.prevAltriCostiGenerali +
          this.bilanciMinisteroActiveData.prevCostiTutelaSanitaria
        );
      },
      set: function () {
        // not usato
      },
    },
    prevDeficit: {
        get: function () {
            const val = this.prevTotaleUscite - this.prevTotaleEntrate;
            return Math.round(val * 100) / 100;
        },
        set: function () {
            // non usato
        },
    },
    consTotaleEntrate: {
      get: function () {
        return (
          this.bilanciMinisteroActiveData.consContrStataliExtraFUS +
          this.bilanciMinisteroActiveData.consContrRegionali +
          this.bilanciMinisteroActiveData.consContrComunali +
          this.bilanciMinisteroActiveData.consContrUE +
          this.bilanciMinisteroActiveData.consContrAltriEntiPubblici +
          this.bilanciMinisteroActiveData.consContrSoggettiPrivati +
          this.bilanciMinisteroActiveData.consSponsorEconomiche +
          this.bilanciMinisteroActiveData.consRimborsiCoproduzione +
          this.bilanciMinisteroActiveData.consAltreEntrateCoproduzione +
          this.bilanciMinisteroActiveData.consEntrateAbbonamenti +
          this.bilanciMinisteroActiveData.consIncassiBiglietteriaProdCoprod +
          this.bilanciMinisteroActiveData.consIncassiBiglietteriaOspitalita +
          this.bilanciMinisteroActiveData.consIncassiPrevendita +
          this.bilanciMinisteroActiveData.consEntrateCompensiAttivita +
          this.bilanciMinisteroActiveData.consAltreEntrateAttivitaCaratteristica +
          this.bilanciMinisteroActiveData.consEntrateServiziAccessori +
          this.bilanciMinisteroActiveData.consAltreEntrateAltreAttivita
        );
      },
      set: function () {
        // non usato
      },
    },
    consTotaleUscite: {
      get: function () {
        return (
          this.bilanciMinisteroActiveData.consOneriSocialiDirettoreArtisticoCaricoA +
          this.bilanciMinisteroActiveData.consCompensoDirettoreArtistico +
          this.bilanciMinisteroActiveData.consRetribuzioneLordaPersonaleArtistico +
          this.bilanciMinisteroActiveData.consOneriSocialiPersonaleArtisticoCaricoA +
          this.bilanciMinisteroActiveData.consRetribuzioneLordaPersonaleTecnico +
          this.bilanciMinisteroActiveData.consOneriSocialiPersonaleTecnicoCaricoA +
          this.bilanciMinisteroActiveData.consRetribuzioneLordaPersonaleAmm +
          this.bilanciMinisteroActiveData.consOneriSocialiPersonaleAmmCaricoA +
          this.bilanciMinisteroActiveData.consDiarieForfettarie +
          this.bilanciMinisteroActiveData.consCompensiOrganismiOspitati +
          this.bilanciMinisteroActiveData.consCostiViaggiTrasportoAlloggiCO +
          this.bilanciMinisteroActiveData.consNoleggiTecniciOsp +
          this.bilanciMinisteroActiveData.consPrestazioniTerziAllestimentiOsp +
          this.bilanciMinisteroActiveData.consSIAEOsp +
          this.bilanciMinisteroActiveData.consVVFCaricoAziendaOsp +
          this.bilanciMinisteroActiveData.consCostiViaggiTrasportoAlloggiProduzioni +
          this.bilanciMinisteroActiveData.consAcquistiSceneCostumiStrumentiProd +
          this.bilanciMinisteroActiveData.consNoleggiSceneCostumiStrumentiProd +
          this.bilanciMinisteroActiveData.consAcquistiStrumentazioneTecnicaNonAmmProd +
          this.bilanciMinisteroActiveData.consNoleggiStrumentazioneTecnicaProd +
          this.bilanciMinisteroActiveData.consAffittoSalaProveProd +
          this.bilanciMinisteroActiveData.consPrestazioniTerziAllestimentiProd +
          this.bilanciMinisteroActiveData.consSIAEProd +
          this.bilanciMinisteroActiveData.consVVFCaricoAziendaProd +
          this.bilanciMinisteroActiveData.consUfficioStampaComunicazione +
          this.bilanciMinisteroActiveData.consCostiStampeDistribAffissione +
          this.bilanciMinisteroActiveData.consCostiPrestazioniPubblProm +
          this.bilanciMinisteroActiveData.consCostiPubblicita +
          this.bilanciMinisteroActiveData.consCostiGestioneManSitoWeb +
          this.bilanciMinisteroActiveData.consCostiPromoPiattDig +
          this.bilanciMinisteroActiveData.consAffittoSpaziSpettacoli +
          this.bilanciMinisteroActiveData.consCostiManOrdinariaSpazi +
          this.bilanciMinisteroActiveData.consUtenze +
          this.bilanciMinisteroActiveData.consPulizieGestSpazi +
          this.bilanciMinisteroActiveData.consQuotaAmmSceneCostumi +
          this.bilanciMinisteroActiveData.consQuotaAmmStrumentTecnica +
          this.bilanciMinisteroActiveData.consMaterialeConsumo +
          this.bilanciMinisteroActiveData.consAffittoUffici +
          this.bilanciMinisteroActiveData.consAltrePrestazioniProfessionali +
          this.bilanciMinisteroActiveData.consUtenzeUffici +
          this.bilanciMinisteroActiveData.consAssicurazioni +
          this.bilanciMinisteroActiveData.consPulizieGenerali +
          this.bilanciMinisteroActiveData.consAltriCostiGenerali +
          this.bilanciMinisteroActiveData.consCostiTutelaSanitaria
        );
      },
      set: function () {
        // not usato
      },
    },
    consDeficit: {
      get: function () {
          const val = this.consTotaleUscite - this.consTotaleEntrate;
          return Math.round(val * 100) / 100;
      },
      set: function () {
        // non usato
      },
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
